import * as React from "react";
import { useState, useEffect} from "react"
import Card from "../core/Card";
import Breadcrumbs from "../core/Breadcrumbs";
import { jfetch, toast } from "../../utils";
import Modal from "../core/Modal";
import DocumentViewer from "../preloaded/DocumentViewer"
import Player from "../preloaded/Player"
import Button from "../core/Button";
import { categories } from "../../libs/commission_calculator_dashboard";
import Loader from "../core/Loader"
import ReactPaginate from "react-paginate";
import styled from "styled-components";

interface IProps {
  userContext?:any;
  category:any;
  course: string;
}

function Resources(props:IProps){
  const [folders, setFolders] =  useState([])
  const [splitFolders, setSplitFolders] = useState([])
  const [splitFiles, setSplitFiles] = useState([])
  const [crumbs, setCrumbs] = useState([{id:props.category.id, name:props.category.name}])
  const [error, set_error] = useState(false);
  const [search, setSearch] = useState('')
  const [searchFolders, setSearchFolders] = useState([])
  const [searchFiles, setSearchFiles] = useState([])
  const [loading, setLoading] = useState(false)

  const [maxPages, setMaxPages] = useState(1);
  const [allFiles, setAllFiles] = useState([])
  const [files, setFiles] = useState([])
  const [pagesFiles, setPagesFiles] = useState([])
  const [pagenum, setPagenum] = useState(0);

  const [linkID, setLinkID] = useState(props.category.id)

  useEffect(() => {
    let total = pagesFiles.reduce((a,b) => a+b.length,0)
    let p = Math.ceil( total/20 ) 
    setMaxPages(p)
  }, [pagesFiles])

  useEffect(() => {
    if(pagesFiles.length > 0){
      setFiles(pagesFiles[pagenum])
    }
  }, [pagenum])  

  useEffect(() => {
    fetchResources(props.category.id, true)
  }, [])

  useEffect(() => {
    setSplitFolders(splitArray(folders))
  }, [folders])

  useEffect(() => {
    setSplitFiles(splitArray(files))
  }, [files])


  // given an array returns an array or arrays with 100 or less each for pages
  function pageFormat(init_array, n=20){
    let new_array = []
    if(init_array.length > 0){
      let pages = Math.ceil(init_array.length / n)
      for(let i=0;i<pages;i++){
        let index = (n*i)
        new_array.push(init_array.slice(index, index+n))
      }
    }
    return new_array
  }


  function splitArray(init_array){
    let new_array = []
    if(init_array.length > 0){
      let pages = Math.ceil(init_array.length / 4)
      for(let i=0;i<pages;i++){
        let index = (4*i)
        new_array.push(init_array.slice(index, index+4))
      }
    }
    return new_array
  }

  function fetchResources(categoryId, can_view){
    setLinkID(categoryId)
    if(can_view){
      jfetch.get(`/resource_categories/${categoryId}/info.json`)
      .then((resp) => {
        setFolders(resp.folders)
        let files = []
        resp.files.data.forEach(file => {
          files.push(file["attributes"])
        });        
        setCrumbs(resp.breadcrumbs)
        if(files.length > 0){
          let pages = pageFormat(files)
          setAllFiles(files)
          setPagesFiles(pages)
          setFiles(pages[pagenum])
        }
      })
    }
    else{
      toast.error('Sorry you do not have Permision to view this')    
    }
  }

  function renderSwitch(type, url = '', vid = '', id=0){
    switch(type) {
      case 'image':
        return (
          <a href={url} target="_blank" rel="noopener noreferrer" >
            <img src={url} className="image-resource img-responsive" />
          </a>
        )
      case 'video':
        return (
          <Player id={vid} sources={{file:url}} />
        )
      case 'pdf':
        return (
          <DocumentViewer url={url} height="250px" />
        )
      case 'word':
        return (
          <DocumentViewer url={url} height="250px" office={true} />
        )
      case 'excel':
        return (
          <DocumentViewer url={url} height="250px" office={true} />
        )
      default: 
          return (
            <a href={`/resources/${id}/download`} target="_blank" rel="noopener noreferrer" className="btn-theme-primary">
              <i className="fa fa-download"></i> <span>Download</span>
            </a>
          )
    }
  }

  function runSearch(){
    setLoading(true)
    jfetch
    .get(`resources/search.json?query=${search}`)
    .then((resp) => {
      setLoading(false)
      setSearchFolders(resp.categories)
      setSearchFiles(resp.resources)
    })
    
  }

  function copy_link(){
    const link = `https://core.chartec.net/library?category=${props.course}&category_id=${linkID}&open_tab=resources`
    navigator.clipboard.writeText(link)
    toast.success('link copied')
  }

  return (
    <>
      <BreadCrumbNav crumbs={crumbs} fetchResources={fetchResources} />
      {error ? <div className="alert alert-danger">To gain access please email membership@chartec.net</div> : ""}
      <div className="row" style={{paddingBottom:'15px'}}>
        <div className="col-lg-6">
          <div className="row">
            <div className="col-lg-12">
              <div className="form-inline resource-search">
                <div className="form-group" style={{marginRight:'10px'}}>
                  <div className="input-group">
                    <div className="input-group-addon"><i className="fa fa-search"></i></div>
                      <input type="text" className="form-control" onChange={(e) => setSearch(e.target.value)} placeholder="Global Search.."/>
                  </div>
                </div>
                <Button color="primary" size="sm" onClick={() => runSearch()}>Search</Button>
              </div>
            </div>
          </div>
          <div className="row">
            { loading && <Loader/> }
            {searchFolders.map((folder) => {
              return (
                <div className="col-lg-12 file-col" key={folder.id}>
                  <div className="search-row">
                    <div>
                      <small>{folder.file_path}</small>
                    </div>
                    <div style={{paddingTop:'10px'}}>
                      <a href={`/library?category=${props.course}&category_id=${folder.id}&open_tab=resources`}><i className="fa fa-folder"/> {folder.name}</a>
                    </div>
                  </div>
                </div>
              )
            })}
            {searchFiles.map((file) => {
              return (
                <div className="col-lg-12 file-col" key={file.id}>
                  <div className="search-row">
                    <div>
                      <small>{file.file_path}</small>
                    </div>
                    <div style={{paddingTop:'10px'}}> 
                      <a href={`/resources/${file.id}`}>{file.name} <i className="fa fa-file"/></a>
                    </div>
                  </div>
                </div>
              )
            })}
          </div>
        </div>
        <div className="col-lg-6 text-right">
          <button className="btn btn-small btn-primary" onClick={copy_link}>
            Link <i className="fa fa-copy"/>
          </button>
        </div>
      </div>
      { folders.length > 0 && (
        <div className="row">
          <div className="col-lg-12">
            <h4>Folders</h4>
          </div>
        </div>
      )}
      { splitFolders.map((folders, i) => <FolderRow folders={folders} fetchResources={fetchResources} key={i} />)}
      { files.length > 0 && (
        <div className="row">
          <div className="col-lg-12">
            <h4>Files</h4>
          </div>
        </div>
      )}
      { splitFiles.map((files, i) => <FileRow files={files} renderSwitch={renderSwitch} key={i} />)}
      { files.length > 0 && (
        <ReactPaginate
          previousLabel={"previous"}
          nextLabel={"next"}
          breakLabel={"..."}
          breakClassName={"break-me"}
          pageCount={maxPages}
          forcePage={0}
          marginPagesDisplayed={1}
          pageRangeDisplayed={3}
          onPageChange={ (p) => setPagenum(p.selected) }
          containerClassName={"pagination"}
          subContainerClassName={"pages pagination"}
          activeClassName={"active"}
        />
      )}
    </>
  )
}

interface FileRowProps{
  files:any;
  renderSwitch:Function;
}

function FileRow(props:FileRowProps){
  return (
    <div className="row">
      { props.files.map((f) => <File file={f} renderSwitch={props.renderSwitch} key={f.id} /> )}
    </div>
  )
}


interface FileProps {
  file:any;
  renderSwitch:Function;
}

function File(props:FileProps){
  return(
    <a href={`/resources/${props.file.id}`}>
    <div className="col-lg-3 folder-card">
      <div className="inner-div">
        <div className="row">
          <div className="col-lg-12">
            {props.renderSwitch(props.file.filetype, props.file.file.url, `${props.file.name}-${props.file.id}`, props.file.id)}
          </div>
        </div>
        <div className="row">
          <div className="col-lg-2">
            <i className="fa fa-<%= resource.file_icon %>" style={{fontSize:'22px'}}></i>
          </div>
          <div className="col-lg-10" style={{fontSize:'16px'}}>
            {props.file.name}
          </div>
        </div>
      </div>
    </div>
  </a>
  )
}

interface FolderRowProps{
  folders:any;
  fetchResources:Function;
}

function FolderRow(props:FolderRowProps){
  return (
    <div className="row">
      {props.folders.map((f) => <Folder folder={f} fetchResources={props.fetchResources} key={f.id} />)}
    </div>
  )
}


interface FolderProps{
  folder:any;
  fetchResources:Function;
}

function Folder (props:FolderProps){
  return (
    <div 
      onClick={ () => {
        props.fetchResources(props.folder.id, props.folder.can_view)
      }} 
    >
      <div className="col-lg-3 folder-card">
        <div className="inner-div">
          <div className="row">
            <div className="col-lg-2">
              <i className="fa fa-folder" style={{fontSize:'21px'}}></i>
            </div>
            <div className="col-lg-10" style={{fontSize:'16px'}}>
              {`${props.folder.name} `} 
              {!props.folder.can_view && <i className="fa fa-lock" style={{color:'#d6741f'}}></i>}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

interface bcnProps{
  crumbs:any;
  fetchResources:Function;
}

function BreadCrumbNav(props){
  return (
    <div className="row hidden-xs hidden-sm breadcrumb-wrapper">
      <div className="col-md-12">
        <h2 className="breadcrumbz">
          {props.crumbs.map((crumb) => {
            return (
              <>
                <a onClick={() => {props.fetchResources(crumb.id, true)} }>
                  {' ' + crumb.name}
                </a> /
              </>
            )
          })}
        </h2>
      </div>
    </div>
  )
}

export default Resources


// WEBPACK FOOTER //
// ./app/javascript/components/pages/Resources.tsx